// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBbexAWXK-PbTSGbCwBkA8U-aSKS7l7t7g",
  authDomain: "social-media-71e90.firebaseapp.com",
  projectId: "social-media-71e90",
  storageBucket: "social-media-71e90.appspot.com",
  messagingSenderId: "40372554528",
  appId: "1:40372554528:web:d644c6c3959d421bb92545",
  measurementId: "G-48F786FH2V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);